import { render } from "./SmsSettings.vue?vue&type=template&id=0141c26d&ts=true"
import script from "./SmsSettings.vue?vue&type=script&lang=ts"
export * from "./SmsSettings.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__